import { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from 'primereact/inputswitch';
import { MultiSelect } from 'primereact/multiselect';
import { TabView, TabPanel } from 'primereact/tabview';
import '../../../assets/css/teacherMasterDetail.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import { InputTextarea } from 'primereact/inputtextarea';
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { apiBase } from '../../../utils/config';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import UploadFile from '../../UploadFile/UploadFile';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import userImage from '../../../assets/images/dune-main-logo.svg';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';


const ViewEditStudentDetails = (props) => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const [securityUserID, setSecurityUserID] = useState("");
    const [personalDetailId, setPersonalDetailId] = useState('');
    const [fullName, setFullName] = useState("");
    const [fullNameErr, setFullNameErr] = useState(false);
    const [fullNameErrText, setFullNameErrText] = useState("");
    const [surName, setSurName] = useState('');
    const [surNameErr, setSurNameErr] = useState(false);
    const [surNameErrText, setSurNameErrText] = useState('');
    const [fName, setFName] = useState('');
    const [fNameErr, setFNameErr] = useState(false);
    const [fNameErrtext, setFNameErrText] = useState('');
    const [mName, setMName] = useState('');
    const [mNameErr, setMNameErr] = useState(false);
    const [mNameErrText, setMNameErrText] = useState('');
    const [studentId, setStudentId] = useState("");
    const [studentIdErr, setStudentIdErr] = useState(false);
    const [studentIdErrText, setStudentIdErrText] = useState('');
    const [mobileNumber, setMobileNumber] = useState("");
    const [mobileNumberErr, setMobileNumberErr] = useState(false);
    const [mobileNumberErrText, setMobileNumberErrText] = useState("");
    const [alternateMobileNumber, setAlternateMobileNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [selectedGender, setSelectedGender] = useState(null);
    const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
    const [selectedNationality, setSelectedNationality] = useState(null);
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [aadharNo, setAadharNo] = useState('');
    const [emailIdErrText, setEmailIdErrText] = useState('');
    const [emailIdErr, setEmailIdErr] = useState(false);
    const [aadharOTP, setAadharOTP] = useState('');
    const [isAadharVerify, setIsAadharVerify] = useState(false);
    const [dob, setDob] = useState('');
    const [doa, setDoa] = useState('');
    const [age, setAge] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [permanentAddress, setPermanentAddress] = useState('');
    const [oldPermanentAddress, setOldPermanentAddress] = useState('');
    const [quotaId, setQuotaId] = useState('');
    const [admissionType, setAdmissionType] = useState('');
    const [applicationNo, setApplicationNo] = useState('');
    const genderOptions = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
    const nationalityOptions = [{ label: 'Indian', value: 'indian' }, { label: 'Other', value: 'other' }];
    const [section, setSection] = useState('Basic Details');
    const [academicSection, setAcademicSection] = useState('Current Details');
    const [admissionId, setAdmissionId] = useState('');
    const [previousSchoolId, setPreviousSchoolId] = useState('');
    const [languageList, setLanguageList] = useState([]);
    const [bloodList, setBloodList] = useState([]);
    const [religionList, setReligionList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const [mediumList, setMediumList] = useState([]);
    const [isRandom, setIsRandom] = useState(false);
    const [profilePath, setProfilePath] = useState(null);
    const statusList = [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' }
    ];
    const [academicYear, setAcademicYear] = useState('');
    const [grNo, setGRNo] = useState('');
    const [studentFullName, setStudentFullName] = useState('');
    const [enrolmentNo, setEnrolmentNo] = useState('');
    const [isD2D, setIsD2D] = useState(false);
    const [isTFW, setIsTFW] = useState(false);
    const [isPhStatus, setIsPhStatus] = useState(false);
    const [phCategoryId, setPhCategoryId] = useState('');
    const [phCategoryList, setPhCategoryList] = useState([]);
    const [nameFormat, setNameFormat] = useState('FirstSurname');
    const [orgType, setOrgType] = useState('');
    const [classList, setClassList] = useState([]);
    const [boardList, setBoardList] = useState([]);
    const [academicYearOptions, setAcademicYearOptions] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [houseList, setHouseList] = useState([]);
    const [studentStatus, setStudentStatus] = useState('');
    const [classNo, setClassNo] = useState('');
    const [classNoErr, setClassNoErr] = useState(false);
    const [classNoErrText, setClassNoErrText] = useState('');
    const [classNoName, setClassNoName] = useState('');
    const [rollNo, setRollNo] = useState('');
    const [house, setHouse] = useState('');
    const [houseName, setHouseName] = useState('');
    const [houseColor, setHouseColor] = useState('');
    const [houseLabelColor, setHouseLabelColor] = useState('');
    const [previousSchoolName, setPreviousSchoolName] = useState('');
    const [previousMedium, setPreviousMedium] = useState('');
    const [previousBoard, setPreviousBoard] = useState('');
    const [failedInAnyClass, setFailedInAnyClass] = useState('');
    const [lastClassNo, setLastClassNo] = useState('');
    const [previousRemark, setPreviousRemark] = useState('');
    const [reasonForLeaving, setReasonForLeaving] = useState('');
    const [transferNo, setTransferNo] = useState('');
    const [leavingNo, setLeavingNo] = useState('');
    const [studentStatusList, setStudentStatusList] = useState([]);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [isNoLogin, setIsNoLogin] = useState(false);
    const [parents, setParents] = useState([]);
    const [parentsErrText, setParentsErrText] = useState('');
    const [parentsErr, setParentsErr] = useState(false);
    const [parentList, setParentList] = useState([]);
    const [parentsDetailList, setParentsDetailList] = useState([]);
    const [imageQuality, setImageQuality] = useState(0.2);
    const [useTransport, setUseTransport] = useState(true);
    const [isEdit, setIsEdit] = useState(false);
    const [schoolId, setSchoolId] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                const effectiveId = loginData?.UserRole === 'Teacher' ? (loginData?.CreatedBy || loginData?._id) : loginData?._id;
                setSchoolId(effectiveId);
                setSecurityUserID(loginData?._id);
                setIsEdit(props?.location?.state?.isEdit)
                await GetStudentStatusList(effectiveId);
                await GetConfigurationData(effectiveId);
                await GetBoardList(effectiveId);
                await GetSectionList(effectiveId);
                await GetHouseList(effectiveId);
                await GetParentList(effectiveId);
                await GetAcademicCalanderTemplateList(effectiveId);
                await getUserDetailById();
                await GetLanguageList();
                await GetBloodList(effectiveId);
                await GetCasteList(effectiveId);
                await GetPhCategoryList(effectiveId);
                await GetReligionList(effectiveId);
                await getPersonDetail();
                await getAdmissionDetail(effectiveId);
                await getPreviousSchoolDetail();
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setImageQuality(!CommonConfig.isEmpty(res?.data?.StudentConfig) ? res?.data?.StudentConfig : 0.2);
                    setNameFormat(res?.data?.NameFormat || 'FirstSurname');
                    setOrgType(res?.data?.OrgType || '');
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetAcademicCalanderTemplateList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAcademicYearOptions(
                        res?.data?.flatMap(y =>
                            y?.CalendarValue?.map(x => ({
                                label: `${y?.TitleName}(${moment(x?.StartDate).format("MM/YYYY")}-${moment(x?.EndDate).format("MM/YYYY")})`,
                                _id: x?._id
                            }))
                        )
                    );
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getUserDetailById = async () => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            Loader.show();
            await api
                .post(APIConstant.path.getUserById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        setFullName(res?.data?.FirstName || '');
                        setStudentFullName(res?.data?.FullName || '');
                        setSurName(res?.data?.SurName || '');
                        setFName(res?.data?.FName || '');
                        setMName(res?.data?.MName || '');
                        setMobileNumber(res?.data?.Phone || '');
                        setEmailAddress(res?.data?.Email || '');
                        setIsNoLogin(res?.data?.IsNoLogin);
                        setProfilePath(res?.data?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${res?.data?.ProfilePhotoUrl}` : userImage);
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const GetLanguageList = async () => {
        try {
            await api.get(APIConstant.path.getLanguageList).then(async response => {
                let res = response;
                if (res.success) {
                    setLanguageList(res?.data?.map(x => ({
                        ...x,
                        label: x?.LanguageName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetBloodList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBloodList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBloodList(res.data.map(x => ({
                        label: x?.BloodName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetCasteList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCasteList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCasteList(res.data.map(x => ({
                        label: x?.CasteName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetPhCategoryList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getPhCategoryList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setPhCategoryList(res.data.map(x => ({
                        label: x?.PhCategoryName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetReligionList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getReligionList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setReligionList(res.data.map(x => ({
                        label: x?.ReligionName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetStudentStatusList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getStudentStatusList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setStudentStatusList(res.data.map(x => ({
                        ...x,
                        label: x?.StatusName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetBoardList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBoardList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBoardList(res.data.map(x => ({
                        ...x,
                        label: x?.BoardName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetSectionList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getSectionList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setSectionList(res.data.map(x => ({
                        ...x,
                        label: x?.SectionName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetHouseList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getHouseList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setHouseList(res?.data?.filter((y) => y?.Status === 'Active')?.map(x => ({
                        ...x,
                        label: x?.HouseName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetParentList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getUser, data).then(async response => {
                let res = response;
                if (res.success) {
                    setParentList(res.data.filter((x) => x.UserType === 'Parent' && x?.Status === 'Active').map(x => ({
                        Gender: x?.Gender,
                        label: `${x?.Name} (${x?.Gender})`,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getPersonDetail = async () => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            Loader.show();
            await api
                .post(APIConstant.path.GetPersonalDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        setPersonalDetailId(res?.data?._id);
                        setStudentId(res?.data?.ProfileId || '');
                        setAadharNo(res?.data?.AadharNo || '');
                        setSelectedGender(res?.data?.Gender || '');
                        setDob(res?.data?.DOB ? new Date(res?.data?.DOB) : '');
                        setAge(calculateAge(res?.data?.DOB ? new Date(res?.data?.DOB) : ''));
                        setSelectedNationality(res?.data?.Nationality || '');
                        setSelectedBloodGroup(res?.data?.BloodGroup || '');
                        setSelectedReligion(res?.data?.Religion || '');
                        setSelectedCategory(res?.data?.Category || '');
                        setLanguages(CommonConfig.isEmpty(res?.data?.Language) || res?.data?.Language === 'undefined' ? [] : res?.data?.Language.split(','));
                        setAlternateMobileNumber(res?.data?.AlternateContact || '');
                        setCurrentAddress(res?.data?.CurrentAddress || '');
                        setPermanentAddress(res?.data?.PermanentAddress || '');
                        setPinCode(res?.data?.PinCode || '');
                        setParents(res?.data?.TypeId ? res?.data?.TypeId?.split(',') : []);
                        setParentsDetailList(res?.data?.ParentChildList || '');
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const getAdmissionDetail = async (userId) => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            Loader.show();
            await api
                .post(APIConstant.path.GetAdmissionDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        let resData = res?.data;
                        if (resData) {
                            await GetClassList(userId, resData?.AcademicYear);
                            setAdmissionId(resData._id);
                            setDoa(resData?.AdmissionDate ? new Date(resData?.AdmissionDate) : '');
                            setAdmissionType(CommonConfig.isEmpty(resData?.AdmissionType) || resData?.AdmissionType === 'undefined' ? '' : resData?.AdmissionType);
                            setQuotaId(CommonConfig.isEmpty(resData?.QuotaId) || resData?.QuotaId === 'undefined' ? '' : resData?.QuotaId);
                            setApplicationNo(CommonConfig.isEmpty(resData?.ApplicationNo) || resData?.ApplicationNo === 'undefined' ? '' : resData?.ApplicationNo);
                            setAcademicYear(resData?.AcademicYear);
                            setGRNo(resData?.GRNo);
                            setEnrolmentNo(CommonConfig.isEmpty(resData?.EnrolmentNo) || resData?.EnrolmentNo === 'undefined' ? '' : resData?.EnrolmentNo);
                            setIsD2D(!!resData?.IsD2D);
                            setIsTFW(!!resData?.IsTFW);
                            setIsPhStatus(!!resData?.IsPhStatus);
                            setPhCategoryId(CommonConfig.isEmpty(resData?.PhCategoryId) || resData?.PhCategoryId === 'undefined' ? '' : resData?.PhCategoryId);
                            setStudentStatus(CommonConfig.isEmpty(resData?.StudentStatus) || resData?.StudentStatus === 'undefined'
                                ? studentStatusList.find(z => z?.label === 'Active')?.value : resData?.StudentStatus);
                            setClassNo(resData?.ClassNo);
                            setClassNoName(resData?.ClassNoName);
                            setRollNo(resData?.RollNo);
                            setHouse(resData?.House);
                            setHouseName(resData?.HouseName);
                            setHouseColor(resData?.HouseColor ? `#${resData?.HouseColor}` : '');
                            setHouseLabelColor(resData?.HouseNameColor ? `#${resData?.HouseNameColor}` : '');
                        }
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const getPreviousSchoolDetail = async () => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            Loader.show();
            await api
                .post(APIConstant.path.GetPreviousSchoolDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        let resData = res?.data;
                        if (resData.length) {
                            setPreviousSchoolId(resData[0]._id);
                            setPreviousSchoolName(resData[0]?.SchoolName);
                            setPreviousMedium(resData[0]?.Medium);
                            setPreviousBoard(resData[0]?.Board);
                            setFailedInAnyClass(resData[0]?.FailedInAny);
                            setLastClassNo(resData[0]?.LastClassStudied);
                            setPreviousRemark(resData[0]?.Remark);
                            setReasonForLeaving(resData[0]?.ReasonLeaving);
                            setTransferNo(resData[0]?.TransferCrtNo);
                            setLeavingNo(resData[0]?.LeavingCrtNo);
                        }
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(fullName) && CommonConfig.isEmpty(studentFullName)) {
            formIsValid = false;
            setFullNameErr(true);
            setFullNameErrText("Either First Name or Full Name is required");
            setActiveTab(0);
        } else {
            setFullNameErr(false);
            setFullNameErrText("");
        }
        if (CommonConfig.isEmpty(mobileNumber) && isNoLogin) {
            formIsValid = false;
            setMobileNumberErr(true);
            setMobileNumberErrText("PhoneNo is required");
            setActiveTab(1);
        } else {
            setMobileNumberErr(false);
            setMobileNumberErrText("");
        }
        if (CommonConfig.isEmpty(emailAddress) && isNoLogin) {
            formIsValid = false;
            setEmailIdErr(true);
            setEmailIdErrText("EmailId is required");
            setActiveTab(1);
        } else {
            setEmailIdErr(false);
            setEmailIdErrText("");
        }
        if (CommonConfig.isEmpty(classNo)) {
            formIsValid = false;
            setClassNoErr(true);
            setClassNoErrText("Class Name is required");
            setActiveTab(3);
        } else {
            setClassNoErr(false);
            setClassNoErrText("");
        }
        return formIsValid;
    };

    const saveDetails = async (e) => {
        if (validate(e)) {
            try {
                const formData = new FormData();
                formData.append("id", props?.location?.state?.userId);
                const composedName = `${fullName} ${fName} ${surName}`.replace(/\s+/g, ' ').trim();
                const typedFullName = studentFullName.trim().replace(/\s+/g, ' ');
                formData.append("Name", typedFullName || composedName);
                formData.append("FirstName", fullName.trim().replace(/\s+/g, ' ') || '');
                formData.append("FullName", studentFullName.trim().replace(/\s+/g, ' ') || '');
                formData.append("SurName", surName.trim().replace(/\s+/g, ' ') || '');
                formData.append("FName", fName.trim().replace(/\s+/g, ' ') || '');
                formData.append("MName", mName.trim().replace(/\s+/g, ' ') || '');
                formData.append("Email", emailAddress || '');
                formData.append("Phone", mobileNumber || '');
                if (profilePath && profilePath.type) {
                    formData.append("userProfilePic", profilePath);
                } else if (CommonConfig.isEmpty(profilePath)) {
                    formData.append("userProfilePic", '');
                }
                formData.append("PersonalId", personalDetailId);
                formData.append("UserId", props?.location?.state?.userId);
                formData.append("AadharNo", aadharNo);
                formData.append("Gender", selectedGender);
                formData.append("DOB", dob ? moment(dob).format("YYYY-MM-DD") : '');
                formData.append("Age", age);
                formData.append("Nationality", selectedNationality);
                formData.append("BloodGroup", selectedBloodGroup);
                formData.append("Religion", selectedReligion);
                formData.append("Category", selectedCategory);
                formData.append("TypeId", parents.length ? (parents.length > 1 ? parents.join(',') : parents[0]) : '');
                formData.append("Language", languages.length > 1 ? languages.join(',') : languages[0]);
                formData.append("AlternateContact", alternateMobileNumber);
                formData.append("PinCode", pinCode);
                formData.append("CurrentAddress", currentAddress.trim().replace(/\s+/g, ' '));
                formData.append("PermanentAddress", permanentAddress.trim().replace(/\s+/g, ' '));
                formData.append("AdmissionId", admissionId);
                formData.append("ParentsId", aadharNo);
                formData.append("AdmissionDate", doa ? moment(doa).format("YYYY-MM-DD") : '');
                formData.append("AdmissionType", admissionType);
                formData.append("QuotaId", quotaId);
                formData.append("EnrolmentNo", orgType === 'College' ? enrolmentNo : '');
                formData.append("IsD2D", orgType === 'College' ? isD2D : false);
                formData.append("IsTFW", isTFW);
                formData.append("IsPhStatus", isPhStatus);
                formData.append("PhCategoryId", phCategoryId || '');
                formData.append("ApplicationNo", applicationNo);
                formData.append("AcademicYear", academicYear);
                formData.append("GRNo", grNo);
                formData.append("StudentStatus", studentStatus);
                formData.append("ClassNo", classNo);
                formData.append("RollNo", rollNo);
                formData.append("House", house);
                formData.append("CreatedBy", schoolId)
                formData.append("UpdatedBy", schoolId);

                Loader.show();
                await api.post(APIConstant.path.AddUpdateStudent, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then(async response => {
                    let res = response;
                    if (res.success) {
                        await AddEditPreviousSchoolDetail();
                        Toast.success({ message: res.message });
                        Loader.hide();
                        navigate(-1)
                    } else {
                        Toast.error({ message: res.message });
                        Loader.hide();
                    }
                })
                    .catch((err) => {
                        Toast.error({ message: err });
                        Loader.hide();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                catchResponse(err);
            }
        }
    }

    const AddEditPreviousSchoolDetail = async () => {
        try {
            let data = {
                id: previousSchoolId,
                UserId: props?.location?.state?.userId,
                SchoolName: previousSchoolName.trim().replace(/\s+/g, ' '),
                Medium: previousMedium,
                Board: previousBoard,
                FailedInAny: failedInAnyClass,
                LastClassStudied: lastClassNo,
                Remark: previousRemark,
                ReasonLeaving: reasonForLeaving,
                TransferCrtNo: transferNo,
                LeavingCrtNo: leavingNo,
                CreatedBy: schoolId,
                UpdatedBy: schoolId
            };
            Loader.show();
            await api.post(APIConstant.path.AddPreviousSchoolDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch(() => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const calculateAge = (dob) => {
        if (!dob) return '';
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const handleDobChange = (e) => {
        const selectedDob = e.value;
        setDob(selectedDob);
        setAge(calculateAge(selectedDob));
    };

    // Recomposed from the edited part because setState has not applied yet.
    const recomposeFullName = (overrides) => {
        setStudentFullName(CommonConfig.composeFullName(nameFormat, {
            FirstName: overrides?.FirstName ?? fullName,
            SurName: overrides?.SurName ?? surName,
            FName: overrides?.FName ?? fName,
            MName: overrides?.MName ?? mName,
        }));
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s]/g, '');

        if (type === 'FullName') {
            setFullName(alphanumericValue);
            recomposeFullName({ FirstName: alphanumericValue });
        } else if (type === 'StudentFullName') {
            setStudentFullName(alphanumericValue);
        } else if (type === 'MobileNo') {
            setMobileNumber(numericValue);
        } else if (type === 'AlternateNo') {
            setAlternateMobileNumber(numericValue);
        } else if (type === 'AadharNo') {
            setAadharNo(numericValue);
        } else if (type === 'Pincode') {
            setPinCode(numericValue);
        } else if (type === 'GRNo') {
            setGRNo(value);
        } else if (type === 'StudentId') {
            setStudentId(alphanumericValue.toUpperCase());
        } else if (type === 'SurName') {
            setSurName(alphanumericValue);
            recomposeFullName({ SurName: alphanumericValue });
        } else if (type === 'FName') {
            setFName(alphanumericValue);
            recomposeFullName({ FName: alphanumericValue });
        } else if (type === 'MName') {
            setMName(alphanumericValue);
            recomposeFullName({ MName: alphanumericValue });
        }
    };

    const handleCheckBox = (e) => {
        setIsRandom(e.checked);
        if (e.checked) {
            setOldPermanentAddress(permanentAddress);
            setPermanentAddress(currentAddress);
        } else {
            setPermanentAddress(oldPermanentAddress);
            setOldPermanentAddress('');
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const maxLength = 50;
        if (value.length <= maxLength) {
            setEmailAddress(value);
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(value)) {
            setEmailIdErr(true);
            setEmailIdErrText('Please enter a valid email address.');
        } else {
            setEmailIdErr(false);
            setEmailIdErrText('');
        }
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (!selectedFile) return;
        const img = new Image();
        img.onload = async () => {
            const aspectRatio = img.width / img.height;
            const expectedRatio = 3 / 4;
            const tolerance = 0.01;

            if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                Toast.error({ message: 'The image must have a 3:4 aspect ratio.' });
                return;
            }
            const canvas = document.createElement('canvas');
            const maxWidth = 300;
            const width = maxWidth;
            const height = width / aspectRatio;

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        const compressedFile = new File([blob], selectedFile.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now()
                        });

                        setProfilePath(compressedFile);
                        const compressedURL = URL.createObjectURL(blob);
                        setPreviewProfilePath(compressedURL);
                    }
                },
                'image/jpeg',
                imageQuality
            );
        };

        img.onerror = () => {
            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }
            Toast.error({ message: 'Error loading the image.' });
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setProfilePath("")
                    setPreviewProfilePath('');
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };
    const handleDelete = () => {
        setIsDeleteConfirmation(true)
    };

    const handleParentChange = (e) => {
        if (e?.value?.length > 2) {
            setParentsErr(true);
            setParentsErrText('You can only select up to 2 parents.');
            return;
        }
        setParentsErr(false);
        setParentsErrText('');
        if (e?.value?.length === 2) {
            const selectedParents = e?.value.map(id => parentList.find(parent => parent?.value === id));
            if (selectedParents[0]?.Gender === selectedParents[1]?.Gender) {
                setParentsErr(true);
                setParentsErrText('Parents must be of opposite genders.');
                return;
            }
            setParentsErr(false);
            setParentsErrText('');
        }

        setParents(e.value);
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    return (
        <div className="student-master-container">
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/student-master')}></i>
                    <h2>{!isEdit ? 'View' : 'Edit'} Student Master</h2>
                </div>
                {!isEdit && (
                    <Button
                        label="Edit"
                        icon="pi pi-pencil"
                        className="btn-text-action-primary"
                        onClick={() => setIsEdit(true)}
                    />
                )}
            </div>
            <div className='student-master-form'>
                <div className='student-profile-header p-d-flex'>
                    <div className="p-d-flex">
                        <div style={{ height: 200, width: 210 }}>
                            <UploadFile label='' note='' preview={previewProfilePath} original={profilePath} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={isEdit} aspectRatio={3/4} />
                        </div>
                        <div className="student-header-profile-info p-pl-2">
                            <h2 className='p-text-justify'>{`${fullName} ${fName} ${surName}`}</h2>
                            <div className='p-d-flex p-ai-center'>
                                <Badge value={`Student UID - ${studentId}`} className='common-badge' />
                                <Badge value={`GR No. - ${grNo}`} className='p-ml-2 common-badge' />
                            </div>
                            <div className='p-d-flex p-ai-center'>
                                <div className="profile-transport-box">
                                    <span className='profile-t-text'>Transport Facility</span>
                                    <div className='transport-controls p-d-flex p-ai-center'>
                                        <InputSwitch checked={useTransport} onChange={(e) => setUseTransport(e.value)} disabled={!isEdit} />
                                        <Button label="Using" className="transport-using-btn p-ml-2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-ml-auto">
                        <div className="p-text-right">
                            <p className='badge-label p-mb-1'>Class</p>
                            <Badge value={classNoName || "Not assigned"} className='class-badge' />
                        </div>
                        <div className="p-d-flex p-jc-end">
                            <div className="">
                                <p className='badge-label p-mb-1 p-text-center'>Roll No.</p>
                                <Badge value={rollNo || "Not assigned"} className="common-badge" />
                            </div>
                            <div className="p-pl-3">
                                <p className='badge-label p-mb-1'>House</p>
                                <Badge value={houseName || "Not assigned"} style={{ background: houseColor, color: houseLabelColor }} className="common-badge" />

                            </div>
                        </div>
                    </div>
                </div>
                <TabView className='p-mt-3' activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                    <TabPanel header="Personal Details">
                        <div className="p-mb-0">
                            <div className="p-grid p-ai-center p-py-2">
                                <div className="p-col-12 p-md-8">
                                    <div className="p-d-flex" role="tablist" aria-label="Personal details tabs">
                                        <Button
                                            type="button"
                                            className={`p-mr-2 pill-btn ${section === 'Basic Details' ? 'pill-btn--active' : ''}`}
                                            label="Basic Details"
                                            icon={section === 'Basic Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setSection('Basic Details')}
                                        />
                                        <Button
                                            type="button"
                                            className={`p-mr-2 pill-btn ${section === 'Birth Place Details' ? 'pill-btn--active' : ''}`}
                                            label="Birth Place Details"
                                            icon={section === 'Birth Place Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setSection('Birth Place Details')}
                                        />
                                        <Button
                                            type="button"
                                            className={`pill-btn ${section === 'Parent Details' ? 'pill-btn--active' : ''}`}
                                            label="Parent Details"
                                            icon={section === 'Parent Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setSection('Parent Details')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-fluid">
                                {section === 'Basic Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="fullName">First Name</label>
                                                <InputText id="fullName" className='p-mt-1' value={fullName} disabled={!isEdit} onChange={(e) => handleChange(e, 'FullName')} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={20} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {fullNameErr ? fullNameErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="surName">Surname</label>
                                                <InputText id="surName" className='p-mt-1' value={surName} disabled={!isEdit} onChange={(e) => handleChange(e, 'SurName')} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={20} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {surNameErr ? surNameErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="fName">Father Name</label>
                                                <InputText id="fName" className='p-mt-1' value={fName} disabled={!isEdit} onChange={(e) => handleChange(e, 'FName')} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={20} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {fNameErr ? fNameErrtext : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="mName">Mother Name</label>
                                                <InputText id="mName" className='p-mt-1' value={mName} disabled={!isEdit} onChange={(e) => handleChange(e, 'MName')} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={20} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {mNameErr ? mNameErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="studentFullName">Full Name</label>
                                                <InputText id="studentFullName" className='p-mt-1' value={studentFullName} disabled={!isEdit} onChange={(e) => handleChange(e, 'StudentFullName')} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={80} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="aadhar">Aadhar</label>
                                                <div className="p-inputgroup p-d-flex p-mt-1 p-ai-center">
                                                    <InputText className='p-w-100' id="aadhar" disabled={!isEdit} value={aadharNo} maxLength={12} onChange={(e) => handleChange(e, 'AadharNo')} />
                                                    <Button className='p-pr-4 p-pl-3' label="Verify" disabled={!isEdit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="gender">Gender</label>
                                                <Dropdown id="gender" className='p-mt-1' disabled={!isEdit} value={selectedGender} options={genderOptions} onChange={(e) => setSelectedGender(e.value)} placeholder="Select Gender" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="dob">Date of Birth</label>
                                                <Calendar className='p-w-100 p-mt-1' id="dob" value={dob} onChange={handleDobChange} disabled={!isEdit} dateFormat='dd/mm/yy' maxDate={new Date()} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="age">Age</label>
                                                <InputText id="age" className='p-mt-1' value={age} disabled />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="nationality">Nationality</label>
                                                <Dropdown id="nationality" className='p-mt-1' value={selectedNationality} disabled={!isEdit} options={nationalityOptions} onChange={(e) => setSelectedNationality(e.value)} placeholder="Select Nationality" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="bloodGroup">Blood Group</label>
                                                <Dropdown id="bloodGroup" className='p-mt-1' value={selectedBloodGroup} options={bloodList} disabled={!isEdit} onChange={(e) => setSelectedBloodGroup(e.value)} placeholder="Select Blood Group" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="religion">Religion</label>
                                                <Dropdown id="religion" className='p-mt-1' value={selectedReligion} options={religionList} disabled={!isEdit} onChange={(e) => setSelectedReligion(e.value)} placeholder="Select Religion" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="category">Category</label>
                                                <Dropdown id="category" className='p-mt-1' value={selectedCategory} options={casteList} disabled={!isEdit} onChange={(e) => setSelectedCategory(e.value)} placeholder="Select Category" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="languages">Languages Spoken</label>
                                                <MultiSelect id="languages" className='p-mt-1' value={languages} options={languageList} disabled={!isEdit} onChange={(e) => setLanguages(e.value)} placeholder="Select language" filter display='chip' />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {section === 'Birth Place Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-4 p-field">
                                            <div className="custom-inputs">
                                                <label htmlFor="pinCode">Pin Code</label>
                                                <InputText id="pinCode" className='p-mt-1' value={pinCode} maxLength={6} disabled={!isEdit} onChange={(e) => setPinCode(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-8 p-field">
                                            <div className="custom-inputs">
                                                <label htmlFor="address">Address</label>
                                                <InputTextarea id="address" className='p-mt-1' value={currentAddress} maxLength={300} type='textArea' rows={3} cols={30} onChange={(e) => setCurrentAddress(e.target.value)} disabled={!isEdit} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {section === 'Parent Details' && (
                                    <div>
                                        <div>
                                            <div className="custom-inputs p-w-100">
                                                <MultiSelect
                                                    id="parents"
                                                    value={parents}
                                                    options={parentList}
                                                    onChange={(e) => handleParentChange(e)}
                                                    placeholder="Select Parents"
                                                    className="p-w-100"
                                                    filter
                                                    display="chip"
                                                />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {parentsErr ? parentsErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12">
                                            <DataTable
                                                value={parentsDetailList}
                                                responsiveLayout="scroll"
                                                className='custom-table'
                                                size='small'
                                            >
                                                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                                                <Column field="name" header="Full Name" />
                                                <Column field="gender" header="Gender" />
                                                <Column field="phone" header="Contact No." />
                                                <Column field="email" header="Email ID" />
                                            </DataTable>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Contact Details">
                        <div className="p-mb-0 p-py-2">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="email">Email Address</label>
                                        <InputText className='p-w-100 p-mt-1' id="email" value={emailAddress} disabled={!isEdit} onChange={(e) => handleEmailChange(e)} />
                                        <span className="p-error block" style={{ color: 'red' }}>
                                            {emailIdErr ? emailIdErrText : null}
                                        </span>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="contactNo">Contact Number</label>
                                        <InputText className='p-w-100 p-mt-1' id="contactNo" maxLength={10} value={mobileNumber} disabled={!isEdit} onChange={(e) => handleChange(e, 'MobileNo')} />
                                        <span className="error-msg" style={{ color: 'red' }}>
                                            {mobileNumberErr ? mobileNumberErrText : null}
                                        </span>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="contactNo">Emergency Contact Number</label>
                                        <InputText className='p-w-100 p-mt-1' id="emrContactNo" maxLength={10} value={alternateMobileNumber} onChange={(e) => handleChange(e, 'AlternateNo')} disabled={!isEdit || isNoLogin} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="pinCode">Pin Code</label>
                                        <InputText className='p-w-100 p-mt-1' id="pinCode" maxLength={6} value={pinCode} disabled={!isEdit} onChange={(e) => handleChange(e, 'Pincode')} />
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="">
                                        <label className='p-d-block' htmlFor="currentAddress">Current Address</label>
                                        <InputTextarea className='p-w-100 p-mt-1' id="currentAddress" value={currentAddress} maxLength={300} type='textArea' rows={3} cols={30} onChange={(e) => setCurrentAddress(e.target.value)} disabled={!isEdit} style={{
                                            fontFamily: "Noto Sans, Arial, sans-serif"
                                        }} />
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="p-d-flex p-ai-center">
                                        <Checkbox
                                            inputId="randomCheckbox"
                                            checked={isRandom}
                                            onChange={(e) => handleCheckBox(e)}
                                            disabled={!isEdit}
                                        />
                                        <label className='p-ml-2' htmlFor="randomCheckbox">Permanent address same as current</label>
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="">
                                        <label className='p-d-block' htmlFor="permanentAddress">Permanent Address</label>
                                        <InputTextarea className='p-w-100 p-mt-1' id="permanentAddress" value={permanentAddress} maxLength={300} rows={3} cols={30} onChange={(e) => setPermanentAddress(e.target.value)} disabled={!isEdit} style={{
                                            fontFamily: "Noto Sans, Arial, sans-serif"
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Admission Details">
                        <div className="p-mb-0 p-py-2">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6">
                                    <div className="custom-inputs">
                                        <label htmlFor="doa">Admission Date</label>
                                        <Calendar className='p-w-100 p-mt-1' id="doa" value={doa} onChange={(e) => setDoa(e.value)} disabled={!isEdit} dateFormat='dd/mm/yy' />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="admissionType">Admission Type</label>
                                        <InputText className='p-w-100 p-mt-1' id="admissionType" maxLength={30} value={admissionType} onChange={(e) => setAdmissionType(e.target.value)} disabled={!isEdit} />
                                    </div>
                                </div>
                                {orgType === 'College' ? (
                                    <div className="p-col-12 p-md-6">
                                        <div className="custom-inputs">
                                            <label className='p-d-block' htmlFor="enrolmentNo">Enrolment Number</label>
                                            <InputText className='p-w-100 p-mt-1' id="enrolmentNo" maxLength={20} value={enrolmentNo} onChange={(e) => setEnrolmentNo(e.target.value)} disabled={!isEdit} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="p-col-12 p-md-6">
                                        <div className="custom-inputs">
                                            <label className='p-d-block' htmlFor="grNo">GR No.</label>
                                            <InputText className='p-w-100 p-mt-1' id="grNo" maxLength={10} value={grNo} onChange={(e) => handleChange(e, 'GRNo')} disabled={!isEdit} />
                                        </div>
                                    </div>
                                )}
                                <div className="p-col-12 p-md-12">
                                    <h4 className='p-m-0 p-pb-2'>Quota Details</h4>
                                    <hr className='p-m-0' />
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="quotaId">Admission Category</label>
                                        <Dropdown id="quotaId" className='p-w-100 p-mt-1' value={quotaId} options={casteList} onChange={(e) => setQuotaId(e.value)} disabled={!isEdit} placeholder="Select Admission Category" showClear filter />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="applicationNo">Application No</label>
                                        <InputText className='p-w-100 p-mt-1' id="applicationNo" maxLength={20} value={applicationNo} onChange={(e) => setApplicationNo(e.target.value)} disabled={!isEdit} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <h4 className='p-m-0 p-pb-2'>Other Details</h4>
                                    <hr className='p-m-0' />
                                </div>
                                {orgType === 'College' ? (
                                    <div className="p-col-12 p-md-3">
                                        <div className="custom-inputs p-d-flex p-ai-center">
                                            <Checkbox inputId="isD2D" checked={isD2D} onChange={(e) => setIsD2D(e.checked)} disabled={!isEdit} />
                                            <label htmlFor="isD2D" className="p-ml-2">D2D</label>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs p-d-flex p-ai-center">
                                        <Checkbox inputId="isTFW" checked={isTFW} onChange={(e) => setIsTFW(e.checked)} disabled={!isEdit} />
                                        <label htmlFor="isTFW" className="p-ml-2">TFW</label>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs p-d-flex p-ai-center">
                                        <Checkbox inputId="isPhStatus" checked={isPhStatus} onChange={(e) => setIsPhStatus(e.checked)} disabled={!isEdit} />
                                        <label htmlFor="isPhStatus" className="p-ml-2">PH Status</label>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="phCategoryId">PH Category</label>
                                        <Dropdown id="phCategoryId" className='p-w-100 p-mt-1' value={phCategoryId} options={phCategoryList} onChange={(e) => setPhCategoryId(e.value)} disabled={!isEdit} placeholder="Select PH Category" showClear filter />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Academic Details">
                        <div className="p-mb-0">
                            <div className="p-grid p-ai-center p-py-2">
                                <div className="p-col-12 p-md-8">
                                    <div className="p-d-flex" role="tablist" aria-label="Academic details tabs">
                                        <Button
                                            type="button"
                                            className={`p-mr-2 pill-btn ${academicSection === 'Current Details' ? 'pill-btn--active' : ''}`}
                                            label="Current Details"
                                            icon={academicSection === 'Current Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setAcademicSection('Current Details')}
                                        />
                                        <Button
                                            type="button"
                                            className={`pill-btn ${academicSection === 'Previous Details' ? 'pill-btn--active' : ''}`}
                                            label="Previous Details"
                                            icon={academicSection === 'Previous Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setAcademicSection('Previous Details')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-fluid">
                                {academicSection === 'Current Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="academicYear">Academic Year</label>
                                                <Dropdown id="academicYear" className='p-mt-1' disabled={!isEdit} value={academicYear} options={academicYearOptions} onChange={(e) => setAcademicYear(e.value)} placeholder="Select Academic Year" showClear optionLabel="label"
                                                    optionValue="_id" filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="studentId">Student UID</label>
                                                <InputText id="studentId" className='p-mt-1' disabled={!isEdit} maxLength={12} onChange={(e) => handleChange(e, 'StudentId')} value={studentId} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {studentIdErr ? studentIdErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="studentStatus">Student Status</label>
                                                <Dropdown id="studentStatus" className='p-mt-1' disabled={!isEdit} value={studentStatus} options={studentStatusList} onChange={(e) => setStudentStatus(e.value)} placeholder="Select Status" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="classNo">Class</label>
                                                <Dropdown id="classNo" className='p-mt-1' disabled={!isEdit} value={classNo} options={classList} onChange={(e) => setClassNo(e.value)} placeholder="Select Class" showClear filter />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {classNoErr ? classNoErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="rollNo">Roll No.</label>
                                                <InputText id="rollNo" className='p-mt-1' value={rollNo} maxLength={10} disabled={!isEdit} onChange={(e) => setRollNo(e.target.value.replace(/[^a-zA-Z0-9_\-/]/g, '').slice(0, 10))} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="house">House</label>
                                                <Dropdown id="house" className='p-mt-1' disabled={!isEdit} value={house} options={houseList} onChange={(e) => setHouse(e.value)} placeholder="Select House" showClear filter />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {academicSection === 'Previous Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="previousSchoolName">School Name</label>
                                                <InputText id="previousSchoolName" className='p-mt-1' value={previousSchoolName} disabled={!isEdit} onChange={(e) => setPreviousSchoolName(e.target.value)} style={{
                                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                                }} maxLength={20} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="previousMedium">Medium</label>
                                                <Dropdown id="previousMedium" className='p-mt-1' disabled={!isEdit} value={previousMedium} options={languageList} onChange={(e) => setPreviousMedium(e.value)} placeholder="Select Medium" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="previousBoard">Board</label>
                                                <Dropdown id="previousBoard" className='p-mt-1' disabled={!isEdit} value={previousBoard} options={boardList} onChange={(e) => setPreviousBoard(e.value)} placeholder="Select Board" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="failedInAnyClass">Failed in Any Class?</label>
                                                <Dropdown id="failedInAnyClass" className='p-mt-1' disabled={!isEdit} value={failedInAnyClass} options={statusList} onChange={(e) => setFailedInAnyClass(e.value)} placeholder="Select" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="lastClassNo">Last Class Studied</label>
                                                <InputText id="lastClassNo" className='p-mt-1' value={lastClassNo} disabled={!isEdit} onChange={(e) => setLastClassNo(e.target.value)} maxLength={20} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="remark">Remark</label>
                                                <InputText id="remark" className='p-mt-1' value={previousRemark} maxLength={100} disabled={!isEdit} onChange={(e) => setPreviousRemark(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="reasonForLeaving">Reason for leaving School</label>
                                                <InputText id="reasonForLeaving" className='p-mt-1' maxLength={100} value={reasonForLeaving} disabled={!isEdit} onChange={(e) => setReasonForLeaving(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="transferNo">Transfer Certificate No</label>
                                                <InputText id="transferNo" className='p-mt-1' value={transferNo} maxLength={100} disabled={!isEdit} onChange={(e) => setTransferNo(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label htmlFor="leavingNo">Leaving Certificate No</label>
                                                <InputText id="leavingNo" className='p-mt-1' value={leavingNo} maxLength={100} disabled={!isEdit} onChange={(e) => setLeavingNo(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            <div className='edit-profile-footer p-d-flex p-jc-end p-ai-center p-pr-4'>
                <Button label="Back" className="btn-text-action-secondary" onClick={() => navigate('/student-master')} />
                {isEdit ?
                    <Button label="Save" className='btn-text-action-primary' icon="pi pi-check" onClick={() => saveDetails()} /> : null}
            </div>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
}

export default ViewEditStudentDetails;
